import api from './api';

export function clearAllData() {
	return (dispatch) => {
		dispatch({
			type: 'USER_LOGOUT'
		});
	};
}

export function getUser() {
	return (dispatch) => {
		dispatch({
			type: 'USER',
			payload: api.post('/profile')
		});
	};
}

export function alert(type, message) {
	return (dispatch) => {
		dispatch({
			type: 'ALERT',
			payload: {
				type,
				message,
				time: new Date()
			}
		});
	};
}


export function getLayoutItem(attribute) {
	return (dispatch) => {
		dispatch({
			type: 'FETCH_ITEM',
			payload: api.get('/' + attribute + '/view'),
			meta: { attribute }
		});
	};
}

export function submitLayoutItem(attribute, data) {
	return (dispatch) => {
		dispatch({
			type: 'SAVE_ITEM',
			payload: api.post('/' + attribute + '/update', data),
			meta: { attribute }
		});
	};
}